<template>
  <div class="new-user box">

    <h4 class="is-size-4">New User</h4>
    <form class=" columns">

      <!-- the new user required fields -->
      <div class="column is-two-thirds">
        <!-- Email -->
        <div class="field columns">
          <div class="column">
            <label class="label is-capitalized">Email</label>
          </div>
          <div class="control column">
            <input type="email" class="input" name="email" v-model="user.email" />
          </div>
        </div>
        <!-- Name -->
        <div class="field columns">
          <div class="column">
            <label class="label is-capitalized">Name</label>
          </div>
          <div class="control column">
            <input type="text" class="input" name="name" v-model="user.name" />
          </div>
        </div>
        <!-- Surname -->
        <div class="field columns">
          <div class="column">
            <label class="label is-capitalized">Surname</label>
          </div>
          <div class="control column">
            <input type="text" class="input" name="surname" v-model="user.surname" />
          </div>
        </div>
        <!-- Password -->
        <div class="field columns">
          <div class="column">
            <label class="label is-capitalized">Password</label>
          </div>
          <div class="control column">
            <input type="password" class="input" name="password" v-model="user.password" />
          </div>
        </div>
      </div>

      <!-- the new user role -->
      <div class="field column is-one-third">
        <label class="label">The New User Role:</label>
        <label class="is-block" v-for="(role, index) in roles" :key="index">
          <input type="radio" name="role" :value="role.value" v-model="user.role"> {{role.label}}
        </label>
      </div>
    </form>

    <!-- the form buttons -->
    <button type="submit" class="button is-info" @click="signUpUser()">Add</button>
    <router-link to="/admin/users" class="button is-danger">Cancel</router-link>
  </div>
</template>

<script>
// import firebase from 'firebase'
import { usersRef, secondaryApp } from '@/firebase_config'

export default {
  name: 'user-new',
  data () {
    return {
      roles: [
        {
          label: 'Admin',
          value: 'admin'
        },
        {
          label: 'Author',
          value: 'author'
        }
      ],
      user: {
        email: '',
        name: '',
        surname: '',
        password: '',
        role: 'author'
      }
    }
  },
  methods: {
    signUpUser () {
      // check if all fields are filled
      if (this.user.email && this.user.password) {
        // workaround https://stackoverflow.com/questions/37517208/firebase-kicks-out-current-user/38013551#38013551
        secondaryApp.auth().createUserWithEmailAndPassword(this.user.email, this.user.password)
          .then((user) => {
            this.addUser(user.uid)
            secondaryApp.auth().signOut()
          })
          .catch(
            err => {
              this.err = Object.assign({}, err)
            }
          )
      } else {
        this.err.code = 'Empty Fields !!'
        this.err.message = 'please fill in all the fields !'
      }
    },
    addUser (userUID) {
      usersRef.child(userUID).set(
        {
          email: this.user.email,
          name: this.user.name,
          surname: this.user.surname,
          role: this.user.role
        }
      ).then((user) => {
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}

</script>

<style>
  .new-user,
  h4 {
    margin-bottom: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/UserNew.vue